"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptType = exports.ApiFilterOperation = void 0;
var ApiFilterOperation;
(function (ApiFilterOperation) {
    ApiFilterOperation["EQ"] = "EQ";
    ApiFilterOperation["START_WITH"] = "START_WITH";
    ApiFilterOperation["END_WITH"] = "END_WITH";
    ApiFilterOperation["CONTAINS"] = "CONTAINS";
    ApiFilterOperation["NOT_NULL"] = "NOT_NULL";
    ApiFilterOperation["IS_NULL"] = "IS_NULL";
    ApiFilterOperation["GT"] = "GT";
    ApiFilterOperation["LT"] = "LT";
    ApiFilterOperation["GTE"] = "GTE";
    ApiFilterOperation["LTE"] = "LTE";
    ApiFilterOperation["FTX"] = "FTX";
    ApiFilterOperation["FTXF"] = "FTXF";
    ApiFilterOperation["OR"] = "OR";
    ApiFilterOperation["AND"] = "AND";
    ApiFilterOperation["NOT"] = "NOT";
    ApiFilterOperation["CUSTOM"] = "CUSTOM";
    ApiFilterOperation["IDS"] = "IDS";
    ApiFilterOperation["IN"] = "IN";
})(ApiFilterOperation = exports.ApiFilterOperation || (exports.ApiFilterOperation = {}));
var ScriptType;
(function (ScriptType) {
    ScriptType["GROOVY"] = "GROOVY";
    ScriptType["JAVASCRIPT"] = "JAVASCRIPT";
})(ScriptType = exports.ScriptType || (exports.ScriptType = {}));
//# sourceMappingURL=common-types.js.map